/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: eventbus.ts
 * Class: eventbus.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

declare global {
    interface Window {
        subscriptions: Subscriptions;
    }
}

interface Subscriptions {
    [key: string]: SubscriptionEvent;
}

interface SubscriptionEvent {
    [key: number] : (...args) => void;
}

window.subscriptions = window.subscriptions || {}
const subscriptions : Subscriptions = window.subscriptions;

const subscribe = (eventType : string, callback: (...args) => void) => {
    const id = getNextUniqueId();

    if(!subscriptions[eventType]) {
        subscriptions[eventType] = { };
    }

    subscriptions[eventType][id] = callback;

    return {
        unsubscribe: () => {
            delete subscriptions[eventType][id];

            if(Object.keys(subscriptions[eventType]).length === 0)
                delete subscriptions[eventType];
        }
    }
};

const publish = (eventType: string, arg) => {
    if(!subscriptions[eventType])
        return;

    Object.keys(subscriptions[eventType]).forEach(
        key => subscriptions[eventType][key](arg)
    )
}


const getIdGenerator = () : () => number => {
    let lastId : number = 0;

    return () => {
        return ++lastId;
    }
};

const getNextUniqueId = getIdGenerator();

export { publish, subscribe };
